"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var AvatarController = (function () {
    function AvatarController(mountReactComponent) {
        this.mountReactComponent = mountReactComponent;
    }
    AvatarController.prototype.setAvatarWithName = function (fullName) {
        var _a = __read(fullName.split(" ").filter(Boolean)), firstName = _a[0], lastName = _a.slice(1);
        this._ui = this.mountReactComponent(react_1.default.createElement(kaleidoscope_1.Avatar, { firstName: firstName, lastName: lastName.join(), isInvite: true }));
    };
    Object.defineProperty(AvatarController.prototype, "ui", {
        get: function () {
            return this._ui;
        },
        enumerable: false,
        configurable: true
    });
    return AvatarController;
}());
exports.default = AvatarController;
